import { render, staticRenderFns } from "./agv-customer-page.vue?vue&type=template&id=77c60014&scoped=true&lang=pug&"
import script from "./agv-customer-page.vue?vue&type=script&lang=js&"
export * from "./agv-customer-page.vue?vue&type=script&lang=js&"
import style0 from "./agv-customer-page.vue?vue&type=style&index=0&id=77c60014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c60014",
  null
  
)

export default component.exports